import * as React from 'react';

import { CurrentCourseItem } from 'bundles/degree-home/components/v2/CurrentCourses/CurrentCourseItem';
import type { GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_inProgress as InProgressCourseState } from 'bundles/degree-home/components/v2/UpcomingCourses/__generated__/getUpcomingCourseStatesQuery';


type Props = {
  inProgressCourses: Array<InProgressCourseState>;
};

export const CurrentCourses: React.FunctionComponent<Props> = ({ inProgressCourses }) => {
  return (
    <div>
      {inProgressCourses.map((courseState) => {
        return <CurrentCourseItem key={courseState.id} courseState={courseState} />;
      })}
    </div>
  );
};
export default CurrentCourses;
